import {defineMessages} from 'react-intl';

const messages = defineMessages({
	title: {
		id: 'devToolkit.title',
		defaultMessage: 'Dev Toolkit',
	},
	sharedBadge: {
		id: 'devToolkit.sharedBadge',
		defaultMessage: 'shared',
	},
	resetAll: {
		id: 'devToolkit.resetAll',
		defaultMessage: 'Reset all',
	},
	applyPreview: {
		id: 'devToolkit.applyPreview',
		defaultMessage: 'Apply preview',
	},
	effectiveDateTimeLabel: {
		id: 'devToolkit.effectiveDateTimeLabel',
		defaultMessage: 'Effective date time',
	},
	dateTimeSharedSubtitle: {
		id: 'devToolkit.dateTimeSharedSubtitle',
		defaultMessage: 'This applies to both the CMS preview and the Storefront toolkit.',
	},
});

export default messages;
